import { z } from 'zod';
import { nonEmptyTrimmed, uuidSchema } from './common.js';
export const createBrandSchema = z.object({ name: nonEmptyTrimmed(80) });
export const updateBrandSchema = z.object({ name: nonEmptyTrimmed(80) });
export const brandSchema = z.object({
    id: uuidSchema,
    name: z.string(),
});
export const brandListResponseSchema = z.object({ items: z.array(brandSchema) });
//# sourceMappingURL=brands.js.map